'use client';
import { Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';

export const DisclaimerResearchContent = () => {
  const t = useT();
  return (
    <Flex flexDir="column" w="full" gap="l" p="2xl" pt="0">
      <Text size="2xl" color="content.primary">
        {t('app.disclaimerEqiResearchHubContentTitle')}
      </Text>
      <Text size="s" color="content.secondary">
        {t('app.disclaimerEqiResearchHubContent')}
      </Text>
    </Flex>
  );
};
